import React from "react";
import clsx from "clsx";

type Tone = "dark" | "light";

export interface DisclaimerFullProps {
  tone?: Tone; // dark = light text for dark bg, light = dark text for light bg
  className?: string;
}

export const DisclaimerFull: React.FC<DisclaimerFullProps> = ({ tone = "light", className }) => {
  const year = new Date().getFullYear();
  const textTone = tone === "dark" ? "text-[#C9D3E1]" : "text-slate-600";

  return (
    <div className={clsx("text-[12px] md:text-[13px] leading-5 font-barlow space-y-3", textTone, className)}>
      <div>
        <span className="font-semibold">Information and Educational Purpose</span>
        <p>
          The information on this website is provided for general informational and educational purposes only and may change without notice. Nothing herein constitutes personalized financial, investment, tax, or legal advice, nor should it be interpreted as a recommendation or solicitation to buy or sell any financial product.
        </p>
      </div>
      <div>
        <span className="font-semibold">No Warranty</span>
        <p>
          While data and insights are derived from sources believed to be reliable, Unis Lumen makes no representation or warranty as to their accuracy, completeness, or timeliness, and assumes no liability for any errors, omissions, or reliance thereon.
        </p>
      </div>
      <div>
        <span className="font-semibold">Investment Risk</span>
        <p>
          All investments involve risk, including potential loss of principal. Past performance does not guarantee future results. The tools within WealthKit™, including RiskIQ Score™, PortfolioIQ™, and AltsIQ™, are designed to support financial literacy and informed decision-making, not to replace professional advice.
        </p>
      </div>
      <div>
        <span className="font-semibold">Professional Advice Required</span>
        <p>
          Decisions related to investment, tax, legal, or financial matters should be made in consultation with qualified professionals who understand your specific circumstances.
        </p>
      </div>
      <p>
        © {year} Unis Lumen. All rights reserved. WealthKit™, RiskIQ Score™, PortfolioIQ™ and AltsIQ™ are trademarks of Unis Lumen.
      </p>
    </div>
  );
};

export default DisclaimerFull;
